import { render } from "./ThirdPartyLicenses.vue?vue&type=template&id=5114f29c&ts=true"
import script from "./ThirdPartyLicenses.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyLicenses.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__